import { defineAsyncComponent } from 'vue';

export default {
    slug: 'document_requests',
    name: 'Document Requests',
    ability: 'document_requests',
    components(app) {
        app.component(
            'app-document-requests',
            defineAsyncComponent(() => import('./components/DocumentRequestsList.vue'))
        );
    },
    routes: [
        {
            path: 'document-requests',
            name: 'document-request-list',
            component: () => import('@modules/DocumentRequests/Resources/js/pages/List.vue'),
            children: [
                {
                    path: ':id(\\d+)',
                    name: 'document-request-preview',
                    component: () => import('@modules/DocumentRequests/Resources/js/pages/Preview.vue'),
                    redirect: { name: 'document-request-overview' },
                    props: true,
                    children: [
                        {
                            path: '/organization/:org/document-requests/:id(\\d+)',
                            name: 'document-request-overview',
                            component: () =>
                                import('@modules/DocumentRequests/Resources/js/pages/preview/Overview.vue'),
                            props: true
                        },
                        {
                            path: 'comments',
                            name: 'document-request-comments',
                            component: () => import('@/components/base/tabs/TabComments.vue'),
                            props: true
                        },
                        {
                            path: 'activities',
                            name: 'document-request-activities',
                            component: () => import('@/components/base/tabs/TabActivities.vue'),
                            props: true
                        },
                        {
                            path: 'documents/:docPath(.*)*',
                            name: 'document-request-documents',
                            component: () => import('@/components/base/tabs/TabDocuments.vue'),
                            props: true
                        },
                        {
                            path: 'logs',
                            name: 'document-request-logs',
                            component: () => import('@/components/base/tabs/TabLogs.vue'),
                            props: true
                        }
                    ]
                }
            ]
        },
        {
            path: 'document-request-templates',
            name: 'document-request-template-list',
            component: () => import('@modules/DocumentRequests/Resources/js/pages/templates/Templates.vue')
        },
        {
            path: 'document-request-templates/new',
            name: 'document-request-template-new',
            component: () => import('@modules/DocumentRequests/Resources/js/pages/templates/TemplateForm.vue')
        },
        {
            path: 'document-request-templates/:id(\\d+)/edit',
            name: 'document-request-template-edit',
            component: () => import('@modules/DocumentRequests/Resources/js/pages/templates/TemplateForm.vue'),
            props: route => ({ id: route.params.id })
        }
    ],
    nav: () => ({
        section: 'crm',
        items: [
            {
                title: i18n.t('Document Requests'),
                icon: 'file-document-multiple-outline',
                to: { name: 'document-request-list' },
                position: 5,
                visible: orgStore => orgStore.canAny('document_requests')
            }
        ]
    }),
    portalRoutes: [
        {
            path: 'document-requests',
            name: 'portal-document-requests',
            component: () => import('@modules/DocumentRequests/Resources/js/portal/List.vue')
        },
        {
            path: 'document-requests/:id(\\d+)',
            name: 'portal-document-request-detail',
            component: () => import('@modules/DocumentRequests/Resources/js/portal/Preview.vue')
        }
    ],
    widgets: () => [
        {
            id: 'document-requests-overview',
            label: i18n.t('Document Requests'),
            icon: 'file-document-multiple-outline',
            component: () =>
                import('@modules/DocumentRequests/Resources/js/pages/dashboards/widgets/DocumentRequestsOverview.vue'),
            size: 'is-4'
        },
        {
            id: 'document-requests-status',
            label: i18n.t('Document requests by status'),
            icon: 'chart-donut',
            component: () =>
                import('@modules/DocumentRequests/Resources/js/pages/dashboards/widgets/StatusBreakdown.vue'),
            size: 'is-4'
        },
        {
            id: 'document-requests-action-required',
            label: i18n.t('Documents to validate'),
            icon: 'clipboard-check-outline',
            component: () =>
                import('@modules/DocumentRequests/Resources/js/pages/dashboards/widgets/ActionRequired.vue'),
            size: 'is-4'
        },
        {
            id: 'document-requests-overdue',
            label: i18n.t('Overdue requests'),
            icon: 'clock-alert-outline',
            component: () => import('@modules/DocumentRequests/Resources/js/pages/dashboards/widgets/Overdue.vue'),
            size: 'is-4'
        }
    ]
};
